import React, { useState, useEffect } from 'react';
import { Row, Col, Label, Input, FormGroup, Tooltip } from 'reactstrap';
import uuid from 'react-uuid';
import Select, { components } from 'react-select';

const Option = (props) => {
    return (
        <div>
            <components.Option {...props}>
                <input
                    type="checkbox"
                    checked={props.isSelected}
                    onChange={() => null}
                />{" "}
                <label>{props.label}</label>
            </components.Option>
        </div>
    );
};

const InfrastructureItemSpecView = ({ handleMultiSelectChange,itemPopupItemFeild, itemPopupItemSepcQ, lookUpList, handleItemSepcValueChange, itemPopupHeader, handleItemPopupHeaderChange }) => {

    const [tooltipOpen, setTooltipOpen] = useState(false);

    const itemTypeFeildList = itemPopupItemFeild.itemFieldTypes;
    const itemFeildCount = itemTypeFeildList.length;

    const toggleTooltip = () => {
        setTooltipOpen(!tooltipOpen)
    };

    useEffect(() => {
        handleHideAllDiv(itemTypeFeildList);

    }, [])

    const handleHideAllDiv = (itemTypeFeildList) => {
        document.querySelectorAll(".item-field").forEach(element => {
            element.style.display = 'none';
        })

        itemTypeFeildList.map(itemTypeFeild => {
            let className = "." + itemTypeFeild.className;
            document.querySelectorAll(className).forEach(element => {
                element.style.display = 'block';
            })
        })
    }

    const selectOptions = [
        { value: "yes", label: "Yes" },
        { value: "no", label: "No" }
    ];

    const WaterTakenOptions = lookUpList.otherWaterTakesLookupList;
    const PondSolidsSpreadTypes = lookUpList.liquidEffluentAppliedLookupList;
    const StructureCleanedOn = lookUpList.structureCleanedOnLookupList
    const WaterMeterTypes = lookUpList.waterMeterTypeLookupList
    const DataCaptureTypes = lookUpList.waterMeterDataCaptureLookupList
    const PurposeOfWatertakeList = lookUpList.purposeOfWatertakeList
    const StationMeasuringTypeList = lookUpList.stationMeasuringTypeList

    if (itemFeildCount > 0) {
        return (
            <>

                {/* Ag chemical storage*/}
                {/*<Row >*/}
                {/*    <Col>*/}
                {/*        <FormGroup className='item-field ag-chemical-spill-prevention'>*/}
                {/*            <Label>Controls in place to contain spills (bunded)</Label>*/}
                {/*            <Input type="textarea" name="AgChemicalSpillPrevention" id="AgChemicalSpillPrevention" value={itemPopupItemSepcQ.AgChemicalSpillPrevention} onChange={handleItemSepcValueChange} />*/}
                {/*        </FormGroup>*/}
                {/*    </Col>*/}
                {/*</Row>*/}

                {/*Farm dairy*/}
                {/*<Row >*/}
                {/*    <Col sm="6">*/}
                {/*        <FormGroup className='item-field dairy-size'>*/}
                {/*            <Label>Dairy Size</Label>*/}
                {/*            <Input type="number" name="DairySize" id="DairySize" value={itemPopupItemSepcQ.DairySize} onChange={handleItemSepcValueChange} />*/}
                {/*        </FormGroup>*/}
                {/*    </Col>*/}
                {/*    <Col>*/}
                {/*        <FormGroup className='item-field is-yard-roofed'>*/}
                {/*            <Label>Is Yard Roofed?</Label> <br />*/}
                {/*            <input className="form-check-input" name="IsYardRoofed" type="checkbox" checked={itemPopupItemSepcQ.IsYardRoofed} onChange={handleItemSepcValueChange} />*/}
                {/*        </FormGroup>*/}
                {/*    </Col>*/}
                {/*    <Col>*/}
                {/*        <FormGroup className='item-field in-shed-feeding'>*/}
                {/*            <Label>In Shed Feeding?</Label><br />*/}
                {/*            <input className="form-check-input" name="InShedFeeding" type="checkbox" checked={itemPopupItemSepcQ.InShedFeeding} onChange={handleItemSepcValueChange} />*/}
                {/*        </FormGroup>*/}
                {/*    </Col>*/}
                {/*</Row>*/}

                {/*Fertiliser storage*/}
                <Row >
                    <Col>
                        <FormGroup className='item-field fertiliser-runoff-prevention'>
                            <Label>Controls in place to prevent runoff i.e. roofed, silo</Label>
                            <Input type="textbox" name="FertiliserRunoffPrevention" id="FertiliserRunoffPrevention" value={itemPopupItemSepcQ.FertiliserRunoffPrevention} onChange={handleItemSepcValueChange} />
                        </FormGroup>
                    </Col>
                </Row>

                {/* Fuel storage*/}
                <Row >
                    <Col>
                        <FormGroup className='item-field leakage-controls'>
                            <Label>Leakage Controls</Label>
                            <Input type="textarea" name="LeakageControls" id="LeakageControls" value={itemPopupItemSepcQ.LeakageControls} onChange={handleItemSepcValueChange} />
                        </FormGroup>
                    </Col>
                </Row>

                {/*Individual Housing barns*/}
                {/*<Row >*/}
                {/*    <Col sm="6">*/}
                {/*        <FormGroup className='item-field barn-size'>*/}
                {/*            <Label>Barn Size (m2)</Label>*/}
                {/*            <Input type="number" name="BarnSize" id="BarnSize" value={itemPopupItemSepcQ.BarnSize} onChange={handleItemSepcValueChange} />*/}
                {/*        </FormGroup>*/}
                {/*    </Col>*/}
                {/*    <Col sm="6">*/}
                {/*        <FormGroup className='item-field barn-outdoor-area-size'>*/}
                {/*            <Label>Barn Outdoor Area size (m2)</Label>*/}
                {/*            <Input type="number" name="BarnOutdoorAreaSize" id="BarnOutdoorAreaSize" value={itemPopupItemSepcQ.BarnOutdoorAreaSize} onChange={handleItemSepcValueChange} />*/}
                {/*        </FormGroup>*/}
                {/*    </Col>*/}
                {/*</Row>*/}

                {/*Other water takes*/}
                {/*<Row >*/}
                {/*    <Col sm="6">*/}
                {/*        <FormGroup className='item-field other-water-takes'>*/}
                {/*            <Label>How water is taken</Label> {' '}*/}
                {/*            <span style={{ textDecoration: 'underline' }} href="#" id="watertakes">*/}
                {/*                ?*/}
                {/*            </span>*/}
                {/*            <Tooltip placement="top" isOpen={tooltipOpen} autohide={false} target="watertakes" toggle={toggleTooltip}>*/}
                {/*                Locate water takes from waterways, springs etc for stock, dairy plant or irrigation use.*/}
                {/*            </Tooltip>*/}
                {/*            {WaterTakenOptions != undefined && WaterTakenOptions != null &&*/}
                {/*                <Input type="select" onChange={handleItemSepcValueChange} name="OtherWaterTakes" id="OtherWaterTakes" value={itemPopupItemSepcQ.OtherWaterTakes}>*/}
                {/*                    <option value={0} >Select type</option>*/}
                {/*                    {WaterTakenOptions.map(Option =>*/}
                {/*                        <option key={uuid()} value={Option.id}>{Option.value}</option>*/}
                {/*                    )}*/}
                {/*                </Input>*/}
                {/*            }*/}
                {/*        </FormGroup>*/}
                {/*    </Col>*/}
                {/*</Row>*/}
                {/*Water Take*/}
                {/*<Row >*/}
                {/*    <Col sm="6">*/}
                {/*        {itemPopupHeader.itemTypeName == 'Water Take' &&*/}
                {/*            <>*/}
                {/*                <FormGroup>*/}
                {/*                    <Label>Type</Label>*/}
                {/*                    <Input type="select" className="float-end validate" onChange={handleItemPopupHeaderChange} name="watertakeType" id="watertakeType" value={itemPopupHeader.watertakeType}>*/}
                {/*                        <option key={0} value={0} >Select Type</option>*/}
                {/*                        {itemPopupHeader.watertakeTypeList != undefined && itemPopupHeader.watertakeTypeList != null && itemPopupHeader.watertakeTypeList.map(Option =>*/}
                {/*                            <>*/}
                {/*                                <option key={Option.id} value={Option.id}>{Option.value}</option>*/}
                {/*                            </>*/}
                {/*                        )}*/}
                {/*                    </Input>*/}
                {/*                </FormGroup>*/}
                {/*            </>*/}
                {/*        }*/}
                {/*    </Col>*/}
                {/*    <Col sm="6">*/}
                {/*        <FormGroup className='item-field purpose-of-water-take'>*/}
                {/*            <Label>Purpose of water take</Label> {' '}*/}
                {/*            {PurposeOfWatertakeList != undefined && PurposeOfWatertakeList != null &&*/}
                {/*                <Input type="select" onChange={handleItemSepcValueChange} name="PurposeOfWatertake" id="PurposeOfWatertake" value={itemPopupItemSepcQ.PurposeOfWatertake}>*/}
                {/*                    <option key={0} value={0} >Select Purpose</option>*/}
                {/*                    {PurposeOfWatertakeList.map(Option =>*/}
                {/*                        <option key={Option.id} value={Option.id}>{Option.value}</option>*/}
                {/*                    )}*/}
                {/*                </Input>*/}
                {/*            }*/}
                {/*        </FormGroup>*/}
                {/*    </Col>*/}
                {/*</Row>*/}

                {/*Pad or Wintering barn*/}
                {/*<Row >*/}

                {/*    <Col>*/}
                {/*        <FormGroup className='item-field the-structure-lined'>*/}
                {/*            <Label> Is the structure lined?</Label> <br />*/}
                {/*            <input className="form-check-input" name="IsStructureLined" type="checkbox" checked={itemPopupItemSepcQ.IsStructureLined} onChange={handleItemSepcValueChange} />*/}
                {/*        </FormGroup>*/}
                {/*    </Col>*/}
                {/*    <Col>*/}
                {/*        <FormGroup className='item-field the-structure-covered'>*/}
                {/*            <Label>Is the structure covered?</Label><br />*/}
                {/*            <input className="form-check-input" name="IsStructureCovered" type="checkbox" checked={itemPopupItemSepcQ.IsStructureCovered} onChange={handleItemSepcValueChange} />*/}
                {/*        </FormGroup>*/}
                {/*    </Col>*/}
                {/*    <Col sm="6">*/}
                {/*        <FormGroup className='item-field where-liquid-effluent-applied'>*/}
                {/*            <Label>Where is the liquid effluent applied?</Label>*/}
                {/*            {PondSolidsSpreadTypes != undefined && PondSolidsSpreadTypes != null &&*/}
                {/*                <Input type="select" onChange={handleItemSepcValueChange} name="LiquidEffluentAppliedIn" id="LiquidEffluentAppliedIn" value={itemPopupItemSepcQ.LiquidEffluentAppliedIn} >*/}
                {/*                    <option value={0} >Select How water is take</option>*/}
                {/*                    {PondSolidsSpreadTypes.map(Option =>*/}
                {/*                        <option key={uuid()} value={Option.id}>{Option.value}</option>*/}
                {/*                    )}*/}
                {/*                </Input>*/}
                {/*            }*/}
                {/*        </FormGroup>*/}
                {/*    </Col>*/}
                {/*</Row>*/}
                {/*<Row >*/}

                {/*    <Col>*/}
                {/*        <FormGroup className='item-field are-solids-seperated-from-liquid-effluent'>*/}
                {/*            <Label>Are solids separated from liquid effluent?</Label> <br />*/}
                {/*            <input className="form-check-input" name="IsSolidsSeperatedFromLiquidEffluent" type="checkbox" checked={itemPopupItemSepcQ.IsSolidsSeperatedFromLiquidEffluent} onChange={handleItemSepcValueChange} />*/}
                {/*        </FormGroup>*/}
                {/*    </Col>*/}
                {/*    <Col>*/}
                {/*        <FormGroup className='item-field is-liquid-effluent-captured-same-as-dairy-effluent'>*/}
                {/*            <Label>Is liquid effluent captured and treated the same as dairy effluent?</Label><br />*/}
                {/*            <input className="form-check-input" name="IsLiquidEffluentTreatedSameAsDairyEffluent" type="checkbox" checked={itemPopupItemSepcQ.IsLiquidEffluentTreatedSameAsDairyEffluent} onChange={handleItemSepcValueChange} />*/}
                {/*        </FormGroup>*/}
                {/*    </Col>*/}
                {/*    <Col sm="6">*/}
                {/*        <FormGroup className='item-field what-is-the-lining-material'>*/}
                {/*            <Label>What is the lining material?</Label>*/}
                {/*            <Input type="textbox" name="LiningMaterial" id="LiningMaterial" value={itemPopupItemSepcQ.LiningMaterial} onChange={handleItemSepcValueChange} />*/}
                {/*        </FormGroup>*/}
                {/*    </Col>*/}
                {/*</Row>*/}
                {/*<Row >*/}
                {/*    <Col>*/}
                {/*        <FormGroup className='item-field how-often-is-this-structure-cleaned'>*/}
                {/*            <Label>How often is this structure cleaned?</Label> <br />*/}
                {/*            {StructureCleanedOn != undefined && StructureCleanedOn != null &&*/}
                {/*                <Input type="select" onChange={handleItemSepcValueChange} name="StructureCleanedOn" id="StructureCleanedOn" value={itemPopupItemSepcQ.StructureCleanedOn}>*/}
                {/*                    <option value={0} >Select</option>*/}
                {/*                    {StructureCleanedOn.map(Option =>*/}
                {/*                        <option key={uuid()} value={Option.id}>{Option.value}</option>*/}
                {/*                    )}*/}
                {/*                </Input>*/}
                {/*            }*/}
                {/*        </FormGroup>*/}
                {/*    </Col>*/}
                {/*    <Col >*/}
                {/*        <FormGroup className='item-field is-the-pad-flushed-with-water-or-scraped'>*/}
                {/*            <Label>Is the pad flushed with water or scraped?</Label>*/}
                {/*            <Row>*/}
                {/*                <Col>*/}
                {/*                    <input type="radio" name="PadType" value="Flushed" onChange={handleItemSepcValueChange} checked={itemPopupItemSepcQ.PadType === "Flushed"} /> {' '}*/}
                {/*                    <Label>Flushed</Label>*/}
                {/*                </Col>*/}
                {/*                <Col>*/}
                {/*                    <input type="radio" name="PadType" value="Scraped" onChange={handleItemSepcValueChange} checked={itemPopupItemSepcQ.PadType === "Scraped"} /> {' '}*/}
                {/*                    <Label>Scraped</Label>*/}
                {/*                </Col>*/}
                {/*            </Row>*/}
                {/*        </FormGroup>*/}
                {/*    </Col>*/}
                {/*</Row>*/}

                {/*Sheds*/}
                {/*<Row >*/}
                {/*    <Col sm="6">*/}
                {/*        <FormGroup className='item-field shed-use'>*/}
                {/*            <Label>Shed Use</Label>*/}
                {/*            <Input type="textbox" name="ShedUse" id="ShedUse" value={itemPopupItemSepcQ.ShedUse} onChange={handleItemSepcValueChange} />*/}
                {/*        </FormGroup>*/}
                {/*    </Col>*/}
                {/*</Row>*/}

                {/*Silage pits*/}
                {/*<Row >*/}
                {/*    <Col sm="6">*/}
                {/*        <FormGroup className='item-field silage-leachate-controls'>*/}
                {/*            <Label>Silage Leachate Controls</Label>*/}
                {/*            <Input type="textbox" name="SilageLeachateControls" id="SilageLeachateControls" value={itemPopupItemSepcQ.SilageLeachateControls} onChange={handleItemSepcValueChange} />*/}
                {/*        </FormGroup>*/}
                {/*    </Col>*/}
                {/*</Row>*/}

                {/*Stock yards (include wool sheds etc)*/}
                {/*<Row >*/}
                {/*    <Col>*/}
                {/*        <FormGroup className='item-field stock-yard-type'>*/}
                {/*            <Label>Stock Yard Type</Label>*/}
                {/*            <Input type="textbox" name="StockYardType" id="StockYardType" value={itemPopupItemSepcQ.StockYardType} onChange={handleItemSepcValueChange} />*/}
                {/*        </FormGroup>*/}
                {/*    </Col>*/}
                {/*    <Col>*/}
                {/*        <FormGroup className='item-field yard-effluent-controls'>*/}
                {/*            <Label>Yard Effluent Controls</Label>*/}
                {/*            <Input type="textbox" name="YardEffluentControls" id="YardEffluentControls" value={itemPopupItemSepcQ.YardEffluentControls} onChange={handleItemSepcValueChange} />*/}
                {/*        </FormGroup>*/}
                {/*    </Col>*/}
                {/*</Row>*/}

                {/*Underpasses*/}
                {/*<Row >*/}
                {/*    <Col sm="6">*/}
                {/*        <FormGroup className='item-field underpass-effluent-management'>*/}
                {/*            <Label>Controls in place to manage effluent</Label>*/}
                {/*            <Input type="textbox" name="UnderpassEffluentManagement" id="UnderpassEffluentManagement" value={itemPopupItemSepcQ.UnderpassEffluentManagement} onChange={handleItemSepcValueChange} />*/}
                {/*        </FormGroup>*/}
                {/*    </Col>*/}
                {/*</Row>*/}

                {/*Waste management*/}
                {/*<Row >*/}
                {/*    <Col>*/}
                {/*        <FormGroup className='item-field recycling'>*/}
                {/*            <Label>Recycling</Label>*/}
                {/*            <Input type="textbox" name="Recycling" id="Recycling" value={itemPopupItemSepcQ.Recycling} onChange={handleItemSepcValueChange} />*/}
                {/*        </FormGroup>*/}
                {/*    </Col>*/}
                {/*    <Col>*/}
                {/*        <FormGroup className='item-field waste-collection'>*/}
                {/*            <Label>Waste Collection</Label>*/}
                {/*            <Input type="textbox" name="WasteCollection" id="WasteCollection" value={itemPopupItemSepcQ.WasteCollection} onChange={handleItemSepcValueChange} />*/}
                {/*        </FormGroup>*/}
                {/*    </Col>*/}
                {/*</Row>*/}

                {/* Water meter*/}
                <Row >
                    <Col>
                        <FormGroup className='item-field water-meter-type'>
                            <Label>Meter Type</Label> <br />
                            {WaterMeterTypes != undefined && WaterMeterTypes != null &&
                                <Input type="select" onChange={handleItemSepcValueChange} name="WatermeterType" id="WatermeterType" value={itemPopupItemSepcQ.WatermeterType}>
                                    <option value={0} >Select</option>
                                    {WaterMeterTypes.map(Option =>
                                        <option key={uuid()} value={Option.id}>{Option.value}</option>
                                    )}
                                </Input>
                            }
                        </FormGroup>
                    </Col>
                    {/*<Col >*/}
                    {/*    <FormGroup className='item-field data-capture-type'>*/}
                    {/*        <Label>Data Capture Type</Label>*/}
                    {/*        {DataCaptureTypes != undefined && DataCaptureTypes != null &&*/}
                    {/*            <Input type="select" onChange={handleItemSepcValueChange} name="DataCaptureType" id="DataCaptureType" value={itemPopupItemSepcQ.DataCaptureType}>*/}
                    {/*                <option value={0} >Select</option>*/}
                    {/*                {DataCaptureTypes.map(Option =>*/}
                    {/*                    <option key={uuid()} value={Option.id}>{Option.value}</option>*/}
                    {/*                )}*/}
                    {/*            </Input>*/}
                    {/*        }*/}
                    {/*    </FormGroup>*/}
                    {/*</Col>*/}
                </Row>
                {/*<Row >*/}
                {/*    <Col>*/}
                {/*        <FormGroup className='item-field is-consent-required'>*/}
                {/*            <Label> Required by consent</Label> <br />*/}
                {/*            <input className="form-check-input" name="IsConsentRequired" type="checkbox" checked={itemPopupItemSepcQ.IsConsentRequired} onChange={handleItemSepcValueChange} />*/}
                {/*        </FormGroup>*/}
                {/*    </Col>*/}
                {/*</Row>*/}
                {/*<Row >*/}
                {/*    <Col>*/}
                {/*        <FormGroup className='item-field is-discharge-contained'>*/}
                {/*            <Label>Is Discharge Contained</Label> <br />*/}
                {/*            <input className="form-check-input" name="IsDischargeContained" type="checkbox" checked={itemPopupItemSepcQ.IsDischargeContained} onChange={handleItemSepcValueChange} />*/}
                {/*        </FormGroup>*/}
                {/*    </Col>*/}
                {/*</Row>*/}
                {/*<Row>*/}
                {/*    <Col sm="6">*/}
                {/*        <FormGroup className='item-field what-is-station-measuring'>*/}
                {/*            <Label>What is station measuring?</Label> {' '}*/}
                {/*            {StationMeasuringTypeList != undefined && StationMeasuringTypeList != null &&*/}
                {/*                <Select className="dropdown" components={{*/}
                {/*                    Option*/}
                {/*            }} placeholder="Select Type" value={itemPopupItemSepcQ.WhatIsStationMeasuring}*/}
                {/*                options={StationMeasuringTypeList} onChange={handleMultiSelectChange} isMulti isClearable />*/}
                {/*            }*/}
                {/*        </FormGroup>*/}
                {/*    </Col>*/}
                {/*    <Col sm="6">*/}
                {/*        <FormGroup className='item-field how-is-the-data-monitored'>*/}
                {/*            <Label>How is the data monitored?</Label>*/}
                {/*            <Input type="select" onChange={handleItemSepcValueChange} name="HowIsTheDataMonitored" id="HowIsTheDataMonitored" value={itemPopupItemSepcQ.HowIsTheDataMonitored}>*/}
                {/*                <option value={0} >Select</option>*/}
                {/*                <option value="Logging and checking">Logging and checking</option>*/}
                {/*                <option value="Service provider monitoring">Service provider monitoring</option>*/}
                {/*            </Input>*/}
                {/*        </FormGroup>*/}
                {/*    </Col>*/}
                {/*</Row>*/}

                {/* Frost protection*/}
                {/*<Row>*/}
                    {/*<Col sm="6">*/}
                    {/*    <FormGroup className='item-field frost-protection-type'>*/}
                    {/*        <Label>Frost protection type</Label>*/}
                    {/*        <Input type="select" onChange={handleItemSepcValueChange} name="FrostProtectionType" id="FrostProtectionType" value={itemPopupItemSepcQ.FrostProtectionType}>*/}
                    {/*            <option value={0} >Select</option>*/}
                    {/*            <option value="Water Protection">Water Protection</option>*/}
                    {/*            <option value="Other Protection">Other Protection</option>*/}
                    {/*        </Input>*/}
                    {/*    </FormGroup>*/}
                    {/*</Col>*/}
                    {/*{itemPopupItemSepcQ.FrostProtectionType == 'Water Protection' &&*/}
                    {/*    <Col sm="6">*/}
                    {/*        <FormGroup className='item-field consent-number'>*/}
                    {/*            <Label>Consent Number</Label> {' '}*/}
                    {/*            <Input type="textbox" name="ConsentNumber" id="ConsentNumber" value={itemPopupItemSepcQ.ConsentNumber} onChange={handleItemSepcValueChange} />*/}
                    {/*        </FormGroup>*/}
                    {/*    </Col>*/}
                    {/*}*/}
                {/*</Row >* /}

                {itemPopupItemSepcQ.FrostProtectionType == 'Water Protection' &&
                    <Row>
                        <Col sm="12">
                            <FormGroup className='item-field manage-water-use-efficently'>
                                <Label>What methods do you use to manage water use efficently</Label>
                                <Input type="textarea" name="ManageWaterUse" id="ManageWaterUse" value={itemPopupItemSepcQ.ManageWaterUse} onChange={handleItemSepcValueChange} />
                            </FormGroup>
                        </Col>
                    </Row>
                }

                {/*Marc Pile / Compost Pad*/}
                <Row >
                    <Col>
                        <FormGroup className='item-field is-marc-green-spread-on-vineyard'>
                            <Label> Is Marc green-spread on vineyard?</Label> <br />
                            <input className="form-check-input" name="IsMarcgreenspread" type="checkbox" checked={itemPopupItemSepcQ.IsMarcgreenspread} onChange={handleItemSepcValueChange} />
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup className='item-field is-marc-stored-at-vineyard'>
                            <Label>Is Marc stored at vineyard?</Label><br />
                            <input className="form-check-input" name="IsMarcstored" type="checkbox" checked={itemPopupItemSepcQ.IsMarcstored} onChange={handleItemSepcValueChange} />
                        </FormGroup>
                    </Col>
                    <Col sm="6">
                        <FormGroup className='item-field containment-system'>
                            <Label>Containment System</Label>
                            <Input type="textbox" name="ContainmentSystem" id="ContainmentSystem" value={itemPopupItemSepcQ.ContainmentSystem} onChange={handleItemSepcValueChange} />

                        </FormGroup>
                    </Col>
                </Row>

                {/*Post Pile*/}
                <Row >
                    <Col>
                        <FormGroup className='item-field is-this-within-20m'>
                            <Label> Is this within 20m of a waterway ?</Label> <br />
                            <input className="form-check-input" name="IsTthisWithin20m" type="checkbox" checked={itemPopupItemSepcQ.IsTthisWithin20m} onChange={handleItemSepcValueChange} />
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup className='item-field is-it-covered'>
                            <Label> Is it covered?</Label><br />
                            <input className="form-check-input" name="IsItCovered" type="checkbox" checked={itemPopupItemSepcQ.IsItCovered} onChange={handleItemSepcValueChange} />
                        </FormGroup>
                    </Col>
                </Row>

                {/*Sediment strip/buffer zone */}
                <Row >
                    <Col>
                        <FormGroup className='item-field height'>
                            <Label> Height</Label> <br />
                            <Input type="number" name="Height" id="Height" value={itemPopupItemSepcQ.Height} onChange={handleItemSepcValueChange} />
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup className='item-field thickness'>
                            <Label> Thickness</Label><br />
                            <Input type="number" name="Thickness" id="Thickness" value={itemPopupItemSepcQ.Thickness} onChange={handleItemSepcValueChange} />
                        </FormGroup>
                    </Col>
                </Row>

                {/*Spray Area*/}
                <Row >
                    <Col>
                        <FormGroup className='item-field buffer-width'>
                            <Label> Buffer width (metres)</Label> <br />
                            <Input type="number" name="BufferWidth" id="BufferWidth" value={itemPopupItemSepcQ.BufferWidth} onChange={handleItemSepcValueChange} />
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup className='item-field area-perimeter-buffered'>
                            <Label> % of area perimeter buffered</Label><br />
                            <Input type="select" onChange={handleItemSepcValueChange} name="Areaperimeterbuffered" id="Areaperimeterbuffered" value={itemPopupItemSepcQ.Areaperimeterbuffered}>
                                <option value={0} >Select</option>
                                <option value="25">25 %</option>
                                <option value="50">50 %</option>
                                <option value="75">75 %</option>
                                <option value="100">100 %</option>
                            </Input>
                        </FormGroup>
                    </Col>
                </Row>
                {/*Track*/}
                <Row >
                    <Col>
                        <FormGroup className='item-field detail-any-cut-out'>
                            <Label> Detail any cut out</Label> <br />
                            <Input type="textarea" name="DetailAnyCutOut" id="DetailAnyCutOut" value={itemPopupItemSepcQ.DetailAnyCutOut} onChange={handleItemSepcValueChange} />
                        </FormGroup>
                    </Col>

                </Row>

                {/*Common*/}
                <Row>
                    <Col sm="3">
                        <FormGroup className='item-field hail-site'>
                            <Label for="HAILsite">HAIL site?</Label>
                            <Input
                                bsSize="sm"
                                type="select"
                                value={itemPopupItemSepcQ.HAILsite}
                                onChange={handleItemSepcValueChange}
                                name="HAILsite"
                                id="HAILsite">
                                <option value=''></option>
                                {selectOptions.map(Option =>
                                    <option key={uuid()} value={Option.id}>{Option.label}</option>
                                )}
                            </Input>
                        </FormGroup>
                    </Col>
                    {/*Sheep Dip Site*/}
                    <Col sm="3">
                        <FormGroup className='item-field current-used'>
                            <Label for="CurrentUsed">Current used</Label>
                            <Input
                                bsSize="sm"
                                type="select"
                                value={itemPopupItemSepcQ.CurrentUsed}
                                onChange={handleItemSepcValueChange}
                                name="CurrentUsed"
                                id="CurrentUsed">
                                <option value=''></option>
                                {selectOptions.map(Option =>
                                    <option key={uuid()} value={Option.id}>{Option.label}</option>
                                )}
                            </Input>
                        </FormGroup>
                    </Col>
                </Row>

                <Row >
                    <Col>
                        <FormGroup className='item-field planted-area'>
                            <label style={{fontSize:"15px"}}> <b>Irrigation</b></label>
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <FormGroup className='item-field planted-area' >
                            <Row style={{ display: "flex" }}>
                                <Col sm="8">
                                    <Label style={{textTransform:"none",fontSize:"14.5px"}}>Is this planted area irrigated?</Label>
                                </Col>
                                <Col sm="4">
                                    <Input type="select" onChange={handleItemSepcValueChange} name="IsIrrigationArea" id="IsIrrigationArea" value={itemPopupItemSepcQ.IsIrrigationArea}>
                                        <option value="" >Select</option>
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                    </Input>
                                </Col>
                            </Row>
                        </FormGroup>
                    </Col>
                </Row>
                <Row >
                    <Col>
                        <FormGroup className='item-field planted-area'>
                            <label style={{ fontSize: "15px" }}> <b>Agrichemical Spray</b></label>
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <FormGroup className='item-field planted-area' >
                            <Row style={{ display: "flex" }}>
                                <Col sm="8">
                                    <Label style={{ textTransform: "none", fontSize: "14.5px" }}>Do you apply agrichemicals to this planted area?</Label>
                                </Col>
                                <Col sm="4">
                                    <Input type="select" onChange={handleItemSepcValueChange} name="IsSprayArea" id="IsSprayArea" value={itemPopupItemSepcQ.IsSprayArea}>
                                        <option value="" >Select</option>
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                    </Input>
                                </Col>
                            </Row>
                        </FormGroup>
                    </Col>
                </Row>
                {itemPopupItemSepcQ.IsSprayArea == 'Yes' &&
                    <>
                    <Row>
                        <Col>
                            <FormGroup className='item-field planted-area' >
                                <Row style={{ display: "flex" }}>
                                    <Col sm="8">
                                        <Label style={{ textTransform: "none", fontSize: "14.5px" }}>Do you have buffer zone/s?</Label>
                                    </Col>
                                    <Col sm="4">
                                        <Input type="select" onChange={handleItemSepcValueChange} name="IsBufferZone" id="IsBufferZone" value={itemPopupItemSepcQ.IsBufferZone}>
                                            <option value="" >Select</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </Input>
                                    </Col>
                                </Row>
                            </FormGroup>
                        </Col>
                    </Row>
                    </>
                }
                {itemPopupItemSepcQ.IsBufferZone == 'Yes' &&
                    <>
                        <Row>
                            <Col sm="6">
                                <FormGroup className=''>
                                <Label>Type of buffer zone</Label><br />
                                <Input type="select" onChange={handleItemSepcValueChange} name="TypeOfBufferZone" id="TypeOfBufferZone" value={itemPopupItemSepcQ.TypeOfBufferZone}>
                                        <option value={0} >Select</option>
                                    <option value="Riparian planting">Riparian planting</option>
                                    <option value="Native planting, e.g. grasses, bushes, trees">Native planting, e.g. grasses, bushes, trees</option>
                                    <option value="Long sward">Long sward</option>
                                    <option value="Shelter belt">Shelter belt</option>
                                    <option value="Other">Other</option>
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col sm="6">
                                <FormGroup className=''>
                                <Label> Width of buffer zone (m)</Label> <br />
                                    <Input type="number" name="BufferWidth" id="BufferWidth" value={itemPopupItemSepcQ.BufferWidth} onChange={handleItemSepcValueChange} />
                                </FormGroup>
                            </Col>
                            
                        </Row>
                    </>
                }
                {itemPopupItemSepcQ.TypeOfBufferZone == 'Other' &&
                    <>
                        <Row>
                            <Col sm="6">
                                <FormGroup className=''>
                                <Label> Please specify</Label> <br />
                                <Input type="text" name="OtherTypeOfBufferZone" id="OtherTypeOfBufferZone" value={itemPopupItemSepcQ.OtherTypeOfBufferZone} onChange={handleItemSepcValueChange} />
                                </FormGroup>
                            </Col>

                        </Row>
                    </>
                }
                <Row >
                    <Col>
                        <FormGroup className='item-field planted-area'>
                            <label style={{ fontSize: "15px" }}> <b>Frost Protection</b></label>
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <FormGroup className='item-field planted-area' >
                            <Row style={{ display: "flex" }}>
                                <Col sm="8">
                                    <Label style={{ textTransform: "none", fontSize: "14.5px" }}>Does this planted area use water for frost protection?</Label>
                                </Col>
                                <Col sm="4">
                                    <Input type="select" onChange={handleItemSepcValueChange} name="IsFrostProtectionArea" id="IsFrostProtectionArea" value={itemPopupItemSepcQ.IsFrostProtectionArea}>
                                        <option value="" >Select</option>
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                    </Input>
                                </Col>
                            </Row>
                        </FormGroup>
                    </Col>
                </Row>
                {itemPopupItemSepcQ.IsFrostProtectionArea == 'Yes' &&
                    <>
                        <Row style={{ display:"none"}}>
                        <Col sm="6">
                            <FormGroup className=''>
                                <Label>Frost protection type</Label>
                                <Input type="select" onChange={handleItemSepcValueChange} name="FrostProtectionType" id="FrostProtectionType" value={itemPopupItemSepcQ.FrostProtectionType}>
                                    <option value={0} >Select</option>
                                    <option value="Water Protection">Water Protection</option>
                                    <option value="Other Protection">Other Protection</option>
                                </Input>
                            </FormGroup>
                        </Col>
                        {itemPopupItemSepcQ.FrostProtectionType == 'Water Protection' &&
                            <Col sm="6">
                                <FormGroup className=''>
                                    <Label>Consent Number</Label> {' '}
                                    <Input type="textbox" name="ConsentNumber" id="ConsentNumber" value={itemPopupItemSepcQ.ConsentNumber} onChange={handleItemSepcValueChange} />
                                </FormGroup>
                            </Col>
                        }
                    </Row>
                    {itemPopupItemSepcQ.FrostProtectionType == 'Water Protection' &&
                        <Row>
                            <Col sm="12">
                                <FormGroup className=''>
                                    <Label>What methods do you use to manage water use efficently</Label>
                                    <Input type="textarea" name="ManageWaterUse" id="ManageWaterUse" value={itemPopupItemSepcQ.ManageWaterUse} onChange={handleItemSepcValueChange} />
                                </FormGroup>
                            </Col>
                        </Row>
                    }
                    </>
                }
                <br />
            </>
        )
    }

}
export default InfrastructureItemSpecView